import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer-wrapper">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-brand">
            <span className="footer-brand-title">UpDeals</span>
            <p className="footer-tagline">
              Your trusted destination for curated online discounts, price error drops,
              coupons, and verified loot deals across top retailers.
            </p>
          </div>

          <ul className="footer-links">
            <li>
              <Link to="/">Deals Feed</Link>
            </li>
            <li>
              <a
                href="https://chat.whatsapp.com/EOSD1FRKL8DG9OXo5qfE2b?mode=ems_copy_t"
                target="_blank"
                rel="noopener noreferrer"
              >
                WhatsApp Alerts
              </a>
            </li>
            <li>
              <a
                href="https://t.me/updealzz"
                target="_blank"
                rel="noopener noreferrer"
              >
                Telegram Channel
              </a>
            </li>
            <li>
              <Link to="/about">About Us</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
            <li>
              <Link to="/privacy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/terms">Terms of Service</Link>
            </li>
            <li>
              <Link to="/affiliate-disclosure">Affiliate Disclosure</Link>
            </li>
            <li>
              <Link to="/amazon-affiliate-agreement">Amazon Agreement</Link>
            </li>
          </ul>
        </div>

        <div className="footer-bottom">
          <p className="footer-disclaimer">
            Disclaimer: As an affiliate, UpDeals may earn a small commission from qualifying
            purchases through links on this website at no additional cost to you. Prices and
            deal validity are subject to retailer stock.
          </p>
          <p className="footer-copyright">
            &copy; {new Date().getFullYear()} UpDeals
            {/* . Powered by{" "}
            <a href="https://upshrink.com" target="_blank" rel="noopener noreferrer">
              UpShrink
            </a>. */}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
